export const QuerieKeys = {
  AUDIT_EVENT: 'auditEvent',
};
